import {t} from 'i18next';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import YesNoDialog from '../../components/YesNoDialog';
import MobileUserService from '../../services/MobileUserService';
import StringUtils from '../../utils/StringUtils';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import ActionButton from '../../components/ActionButton';
// import InputFileUploadComponent from '../../components/inputs/InputFileUploadComponent';
// import { FileUpload } from 'primereact/fileupload';
// import { ProgressSpinner } from 'primereact';
// import { ProgressBar } from 'react-bootstrap';
import ImportUsersDialog from './ImportUsersDialog';
import ResetWalletPointsDialog from './ResetWalletPointsDialog';
import { Button, Menu } from 'primereact';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';

class MobileUserListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new MobileUserService());
        this.demoMode = process.env.REACT_APP_DEMO_MODE === "true";
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            roleOptions: [],
            element: {
                files: [],
            },
            importDialog: false,
            resetPointsDialog: false,
        };
        this.handleOpenNewUserDialog = this.handleOpenNewUserDialog.bind(this);
        this.handleOpenNewOfficeDialog = this.handleOpenNewOfficeDialog.bind(this);
        this.handleCloseUserDialog = this.handleCloseUserDialog.bind(this);
        this.handleOpenEditDialog = this.handleOpenEditDialog.bind(this);
        this.handleOpenRemoveDialog = this.handleOpenRemoveDialog.bind(this);
        this.hideDeleteDialog = this.hideDeleteDialog.bind(this);
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.userId = this.authService.getUserId();
        this.getSelection = this.getSelection.bind(this);
        this.handleImportDialog = this.handleImportDialog.bind(this);
        this.handleCloseImportDialog = this.handleCloseImportDialog.bind(this);
        this.handleOpenResetPointsDialog = this.handleOpenResetPointsDialog.bind(this);
        this.handleCloseResetPointsDialog = this.handleCloseResetPointsDialog.bind(this);
    }
    getDataKey() {
        return 'id';
    }

    getListTitle() {
        return 'user.listTitle';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateSearchCriteria(criteria) {
        return {
            email: criteria.email,
            name: criteria.name,
            role: criteria.role,
            firstResult: criteria.firstResult,
            status: criteria.status,
            onlyInvitedUsers: criteria.onlyInvitedUsers,
            maxResults: criteria.maxResults,
            roles: criteria.roles,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            email: '',
            name: '',
            status: undefined,
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
            onlyInvitedUsers: false,
        };
    }
    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('UserActivityStatus')
            .then((statuses) => {
                statuses = statuses.filter((status) => status.enumValue !== 'REMOVED');
                this.setState({
                    statuses,
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    getCriteriaName() {
        return 'mobile-user-list-sc';
    }

    getContainerListName() {
        return 'mobile-user-list-container';
    }
    getResponsiveLayout() {
        return 'stack';
    }
    getResponsiveBreakpoint() {
        return '991px';
    }
    useMobileStackLayout() {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.innerWidth <= 991;
    }
    avatarTemplate = (rowData) => {
        const fileUuid = rowData?.avatar?.fileUuid;
        const avatarPath = this.service.getPath() + `/${fileUuid}/avatar/current-user`;
        const img = StringUtils.isBlank(fileUuid) ? (
            ''
        ) : (
            <img
                src={`${avatarPath}?token=${this.authService.getToken()}`}
                alt='Avatar'
                // src={`https://source.unsplash.com/random/800x600`}
                className='product-image'
                style={{borderRadius: '50%', height: '30px', width: '30px', marginBottom: '-10px', marginTop: '-10px'}}
            />
        );
        return img;
    };
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    label={t('user.email')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.email}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('user.name')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaDropdownComponent
                    id='status'
                    name='status'
                    showClear
                    colClass='col-lg-3 col-sm-6'
                    label={t('user.list.criteria.status')}
                    value={this.state.criteria.status}
                    options={this.state.statuses}
                    placeholder={t('setting.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    filter
                />
                 <CriteriaCheckboxComponent
                    id='onlyInvitedUsers'
                    name='onlyInvitedUsers'
                    colClass='col-lg-3 col-sm-12'
                    label={t('user.list.criteria.onlyInvitedUsers')}
                    refreshFromBackend
                    value={this.state.criteria.onlyInvitedUsers}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                                    />
            </div>
        );
    }
    handleOnSelectionChange(e) {
        if (this.props.handleUserSelectionChange) {
            this.props.handleUserSelectionChange(e.value);
        }
    }

    prepareColumns() {
        const {t} = this.props;

        let columns = [
            {field: 'email', header: t('mobileUser.email'), sortable: true},
            {field: 'avatar', header: t('mobileUser.avatar'), body: this.avatarTemplate},
            {field: 'name', header: t('mobileUser.nick'), sortable: true},
            {field: 'firstName', header: t('mobileUser.firstName'), sortable: true},
            {field: 'lastName', header: t('mobileUser.lastName'), sortable: true},
            {field: 'wallet.actual', header: t('mobileUser.points'), float: 'right', sortable: true},
            {field: 'wallet.moneyActual', header: t('mobileUser.moneyActual'), float: 'right', sortable: true},
            {field: 'wallet.moneyTotal', header: t('mobileUser.moneyTotal'), float: 'right', sortable: true},
            {
                field: 'workDistance',
                header: t('mobileUser.declared'),
                float: 'right',
                sortable: true
            },
            {field: 'status', header: t('global.status'), float: 'center'},
        ];
        if (!this.props.embedded) {
            columns.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                float: 'center',
                className: 'table-column-action',
            });
        }

        if (columns.length > 0 && !this.useMobileStackLayout()) {
            columns = columns.map((col, index) => {
                if (index === 0) {
                    const firstColumnWidth = col.width ?? '280px';
                    return {
                        ...col,
                        frozen: true,
                        alignFrozen: 'left',
                        width: firstColumnWidth,
                        headerStyle: {
                            ...(col.headerStyle || {}),
                            width: firstColumnWidth,
                            minWidth: firstColumnWidth,
                            maxWidth: firstColumnWidth,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        bodyStyle: {
                            ...(col.bodyStyle || {}),
                            width: firstColumnWidth,
                            minWidth: firstColumnWidth,
                            maxWidth: firstColumnWidth,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                    };
                }
                if (index === columns.length - 1) {
                    const lastColumnWidth = col.key === 'actions' ? '88px' : '140px';
                    return {
                        ...col,
                        frozen: true,
                        alignFrozen: 'right',
                        width: col.width ?? lastColumnWidth,
                        headerStyle: {
                            ...(col.headerStyle || {}),
                            width: col.width ?? lastColumnWidth,
                            minWidth: col.width ?? lastColumnWidth,
                            maxWidth: col.width ?? lastColumnWidth,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        bodyStyle: {
                            ...(col.bodyStyle || {}),
                            width: col.width ?? lastColumnWidth,
                            minWidth: col.width ?? lastColumnWidth,
                            maxWidth: col.width ?? lastColumnWidth,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                    };
                }
                return col;
            });
        }

        return columns;
    }
    breadCrumbItems() {
        const {t} = this.props;
        return !!this.props.embedded ? [] : [{name: t('mobileUser.listTitle'), url: '/mobile-user-list'}];
    }
    prepareHeaderItems() {
        const {t} = this.props;
        return [];
    }

    handleImportDialog(){
        this.setState({
            importDialog: true
        });
    }

    handleCloseImportDialog() {
        this.setState({
            importDialog: false
        });
    }

    handleOpenResetPointsDialog() {
        this.setState({resetPointsDialog: true});
    }

    handleCloseResetPointsDialog() {
        this.setState({resetPointsDialog: false});
    }

    tableHeader() {
        return this.isUserInRole('ROLE_ADMINISTRATOR') ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <ActionButton
                    id='addMobileUser'
                    label='Dodaj użytkownika'
                    iconName={'mdi-plus'}
                    iconSide='left'
                    handleClick={this.handleGoToNew}
                />
                <ActionButton
                    id='importMobileUsers'
                    label='Import'
                    iconName={'mdi-plus'}
                    iconSide='left'
                    handleClick={this.handleImportDialog}
                />
                <ActionButton
                    reverse
                    id='exportMobileUsers'
                    label={t('mobileUser.export')}
                    handleClick={() => {
                        this.service.export(this.state.criteria, t('mobileUser.listTitle'), 'xlsx').catch(() => {
                            this.showErrorMessage(t('mobileUser.export-error'));
                        });
                    }}
                />
                <ActionButton
                    reverse
                    id='resetWalletPoints'
                    label={t('mobileUser.resetPoints.button')}
                    className='red-button'
                    handleClick={this.handleOpenResetPointsDialog}
                />
            </div>
        ) : null;
    }

    //override
    afterRowSelected(e) {
        if (e?.originalEvent?.defaultPrevented === false && e?.value?.length > 0) {
            this.handleOpenEditDialog(e.originalEvent, e?.value[0].id);
        }
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
    
        const menuItems = [
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => {
                    const { detailsUrl } = this.props;
                    const detailHref = `${detailsUrl}/${rowData?.id}/${rowData.invitedUser}`;
                    this.handleGoToDetail(detailHref);
                }
            },
            !this.demoMode && {
                label: t('global.remove'),
                icon: 'pi pi-trash',
                command: (event) => this.handleOpenRemoveDialog(event, rowData),
                className: 'text-red'
            }
        ].filter(Boolean); // Usuwa `false` wartości jeśli `this.demoMode === true`
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    
    handleOpenNewOfficeDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogOfficeVisibile: true, dialogViewMode: 'NEW'});
    }

    handleOpenNewUserDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, dialogViewMode: 'NEW'});
    }
    handleOpenEditDialog(e, id) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, dialogViewMode: 'EDIT', elementId: id});
    }

    handleCloseUserDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: false, elementId: undefined}, () => {
            if (callback) callback();
        });
    }
    handleOpenRemoveDialog(e, element) {
        
        this.setState({removeDialog: true, elementToRemove : element});
    }
    hideDeleteDialog(callBack) {
        this.setState({removeDialog: false, elementToRemove: null}, () => {
            if (callBack) callBack();
        });
    }
    getSelection() {
        return this.props.selectedList;
    }

    render() {
        const { t } = this.props;
        const { importDialog, resetPointsDialog } = this.state;

        return (
            <div className='container-fluid'>
                {resetPointsDialog && (
                    <ResetWalletPointsDialog
                        visible={resetPointsDialog}
                        onHide={this.handleCloseResetPointsDialog}
                        criteria={this.state.criteria}
                        onSuccess={() => this.refreshTable()}
                        showErrorMessage={this.showErrorMessage.bind(this)}
                        showSuccessMessage={this.showSuccessMessage.bind(this)}
                        blockUi={this.blockUi.bind(this)}
                        unblockUi={this.unblockUi.bind(this)}
                    />
                )}
                {this.state.removeDialog && (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onRemoveAction(() => {
                                    this.hideDeleteDialog(() => {
                                        this.showSuccessMessage(t('user.removeUserConfirmation'));
                                        this.refreshTable();
                                        this.unblockUi();
                                    });
                                });
                            } else {
                                this.hideDeleteDialog();
                            }
                        }}
                        visible={this.state.removeDialog}
                        header={t('user.removeDialogHeader')}
                        name='visible'
                        onHide={() => {
                            this.setState({ removeDialog: false });
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('user.userRemoveConfirmation')}
                    </YesNoDialog>
                )}
    
                {importDialog && (
                    <ImportUsersDialog
                        key={`setting-dialog-${this.state.element?.id}`}
                        onHide={(e)=>{
                            this.setState({importDialog: false})
                        }}
                        visible={this.state.importDialog}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showErrorMessage={this.showErrorMessage}
                        showSuccessMessage={this.showSuccessMessage}
                    />
                )}
                <div id="mobile-user-list-container">
                    {this.renderView()}
                </div>
            </div>
        );
    }    
    
    onRemoveAction(callback) {
        this.blockUi();
        if(this.state.elementToRemove.invitedUser){
            this.service
            .removeInvitation(this.state.elementToRemove.id)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.hideDeleteDialog();
            });
        }else {
            this.service
            .remove(this.state.elementToRemove.id)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.hideDeleteDialog();
            });
        }
    }
}

MobileUserListContainer.defaultProps = {
    detailsUrl: '/mobile-user/details',
    newUrl: '/mobile-user/new',
    lazy: true,
};

MobileUserListContainer.propTypes = {};

export default withRouter(withTranslation()(MobileUserListContainer));
